export default __webpack_public_path__ + "static/media/shopify.16d2ef79.svg";